export default __webpack_public_path__ + "static/media/F0006.bcea1946.png";